<template>
	<div class="cs_title">
		<h2 class="animated">客服中心</h2>
		<div class="cus_login_wrapper login fl">
			<div class="login_box">
				<span class="logo">服務條款</span>
				<div style="text-align: left;padding:10px 20px">
					<p style="background-color:#ffffff; margin:15pt 0pt 7.5pt; text-align:center">
						<span style="font-family:微軟正黑體; font-size:12pt; font-weight:bold">荷米斯遊戲</span>
						<span style="font-family:微軟正黑體; font-size:12pt; font-weight:bold">服務合約書</span>
					</p>
					<p style="background-color:#ffffff; margin:15pt 0pt 7.5pt; text-indent:24pt">
						<span style="font-family:微軟正黑體; font-size:12pt">為保障會員</span>
						<span style="font-family:微軟正黑體; font-size:12pt">（</span>
						<span style="font-family:微軟正黑體; font-size:12pt">以下簡稱消費者：會員個人資料請於註冊頁面填寫</span>
						<span style="font-family:微軟正黑體; font-size:12pt">）使用</span>
						<span style="font-family:微軟正黑體; font-size:12pt">荷米斯</span>
						<span style="font-family:微軟正黑體; font-size:12pt">遊戲</span>
						<span
							style="font-family:微軟正黑體; font-size:12pt">有限公司（以下簡稱企業經營者）網站以及企業經營者現在正在提供和將來可能向消費者提供的網路相關服務和手機遊戲服務（以下簡稱『本服務』），之相關權益，請於註冊登記使用本服務前，詳細閱讀以下合約條款約定；另外，因本合約條款之相關內容可能因相關法令變更而調整，若有變動，會依消費者提供之電子信箱發送資料通知消費者，並另行公告於遊戲內，為保障消費者的權益，</span>
						<span style="font-family:微軟正黑體; font-size:12pt">敬請定期查閱！</span>
					</p>
					<p style="background-color:#ffffff; margin:15pt 0pt 7.5pt">
						<span style="font-family:微軟正黑體; font-size:12pt; font-weight:bold">企業經營者基本資料：</span>
					</p>
					<p style="margin:0pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">公司名稱：</span>
						<span style="font-family:微軟正黑體; font-size:12pt">荷米斯</span>
						<span style="font-family:微軟正黑體; font-size:12pt">遊戲</span>
						<span style="font-family:微軟正黑體; font-size:12pt">有限公司</span>
					</p>
					<p style="margin:0pt">
						<span style="font-family:微軟正黑體; font-size:12pt">電子郵件</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">：</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">service@hermesgames.com.tw</span>
					</p>
					<p style="margin:0pt">
						<span style="background-color:#ffffff; color:#222222; font-family:微軟正黑體; font-size:12pt">代表人：詹益華</span>
						<br />
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">營業所地址：</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">新北市三重區重新路四段63號11樓</span>
						<br />
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">統一編號：</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">82909803</span>
						<br />
						<span style="font-family:微軟正黑體; font-size:12pt">電話：</span>
						<span style="font-family:微軟正黑體; font-size:12pt">02-2768-6679</span>
					</p>
					<p style="margin:0pt">
						<span style="font-family:微軟正黑體; font-size:12pt">&#xa0;</span>
					</p>
					<p style="background-color:#ffffff; margin:15pt 0pt 7.5pt">
						<span style="font-family:微軟正黑體; font-size:12pt; font-weight:bold">第一條 法定代理人</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">一、
							消費者為限制行為能力人者，本契約訂定時，應經消費者之法定代理人同意，本契約始生效力；消費者為無行為能力人者，本契約之訂定，應由消費者之法定代理人代為之。</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">二、
							若有限制行為能力人未經同意或無行為能力人未由法定代理人代為付費購買點數致生法定代理人主張退費時，法定代理人得依</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">客服提供之</span>
						<span
							style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">流程，備妥證明文件並提出申請，經企業經營者確認後，退還消費者未使用之遊戲費用。</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">三、
							企業經營者應於遊戲登入頁面或購買頁面以中文明顯標示，若消費者為限制行為能力人或無行為能力人，除應符合第一項規定外，並應於消費者之法定代理人閱讀、瞭解並同意本契約之所有內容後，方得使用本遊戲服務，本契約條款變更時亦同。</span>
						<br />
						<span style="font-family:微軟正黑體; font-size:12pt">&#xa0;</span>
					</p>
					<p style="background-color:#ffffff; margin:15pt 0pt 7.5pt">
						<span style="font-family:微軟正黑體; font-size:12pt; font-weight:bold">第二條 契約內容</span>
					</p>
					<p style="margin:0pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">一、 以下視為本契約之一部分，與本契約具有相同之效力：</span>
						<br />
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">1. 企業經營者有關本遊戲服務之廣告或宣傳內容。</span>
						<br />
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">2. 計費制遊戲之費率表及遊戲管理規則。</span>
						<br />
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">本契約條款如有疑義時，應為消費者有利之解釋。</span>
						<br />
						<span style="font-family:微軟正黑體; font-size:12pt">&#xa0;</span>
					</p>
					<p style="background-color:#ffffff; margin:15pt 0pt 7.5pt">
						<span style="font-family:微軟正黑體; font-size:12pt; font-weight:bold">第三條 契約解除權規定</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">一、
							消費者得於開始遊戲後七日內，以書面告知企業經營者解除本契約，消費者無需說明理由及負擔任何費用。</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">二、
							前項情形，消費者得就未使用之付費購買點數向企業經營者請求退費。</span>
						<br />
						<span style="font-family:微軟正黑體; font-size:12pt">&#xa0;</span>
					</p>
					<p style="background-color:#ffffff; margin:15pt 0pt 7.5pt">
						<span style="font-family:微軟正黑體; font-size:12pt; font-weight:bold">第四條 計費標準</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">一、 本遊戲服務之收費計算方式為：免費制</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">二、 本遊戲服務內</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">（</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">例如：遊戲商城、</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">線上商店</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">等</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">）</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">有提供需消費者額外付費購買之點數、商品或其他服務</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">（</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">例 如：虛擬貨幣或寶物、進階道具等</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">）</span>
						<span
							style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">，企業經營者應在遊戲登入頁面或購買頁面公告載明付款方式及商品資訊。</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">三、
							費率調整時，企業經營者應於預定調整生效日三十日前於</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">官方粉絲團</span>
						<span
							style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">、遊戲登入頁面或購買頁面公告；若消費者於註冊帳號時已登入通訊資料者，並依消費者登入之通訊資料通知消費者</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">。</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">四、
							費率如有調整時，應自調整生效日起按新費率計收；若新費率高於舊費率時，消費者在新費率生效日前已</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">於官網中</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">登入之付費購買點數或遊戲費用應依舊費率計收。</span>
						<br />
						<span style="font-family:微軟正黑體; font-size:12pt">&#xa0;</span>
					</p>
					<p style="background-color:#ffffff; margin:15pt 0pt 7.5pt">
						<span style="font-family:微軟正黑體; font-size:12pt; font-weight:bold">第五條 本遊戲服務應載明之資訊</span>
					</p>
					<p style="margin:0pt; padding-left:21.25pt; text-indent:-21.25pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">一、
							企業經營者應於遊戲網站及遊戲套件包裝上載明以下事項：</span>
						<br />
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">1.
							依電腦軟體分級管理辦法規定標示遊戲分級級別及禁止或適合使用之年齡層。</span>
						<br />
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">2. 進行本遊戲服務之最低軟硬體需求。</span>
						<br />
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">3. 有提供安全裝置者，其免費或付費資訊。</span>
						<br />
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">4.
							有提供付費購買之機會中獎商品或活動，其活動內容、獎項及中獎等資訊，並展示必要揭露之相關中獎機率且</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">記</span>
						<span
							style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">載「此為機會中獎商品，消費者購買或參與活動不代表即可獲得特定商品」等提示。</span>
						<br />
						<span style="font-family:微軟正黑體; font-size:12pt">&#xa0;</span>
					</p>
					<p style="background-color:#ffffff; margin:15pt 0pt 7.5pt">
						<span style="font-family:微軟正黑體; font-size:12pt; font-weight:bold">第六條 帳號密碼之使用</span>
					</p>
					<p style="margin:0pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">一、
							消費者完成註冊程序後取得之帳號及密碼，僅供消費者使用。</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">二、
							前項之密碼得依企業經營者提供之修改機制進行變更。企業經營者人員（含客服人員、遊戲管理員）不得主動詢問消費者之密碼。企業經營者應於契約終止後三十日內，保留消費者之帳號及附隨於該帳號之電磁紀錄。</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">三、
							契約非因可歸責消費者之事由而終止者，消費者於前項期間內辦理續用後，有權繼續使用帳號及附隨於該帳號之電磁紀錄。</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">四、
							第二項期間屆滿時，消費者仍未辦理續用，企業經營者得刪除該帳號及附隨於該帳號之所有資料，但法令另有規定者不在此限。</span>
						<br />
						<span style="font-family:微軟正黑體; font-size:12pt">&#xa0;</span>
					</p>
					<p style="background-color:#ffffff; margin:15pt 0pt 7.5pt">
						<span style="font-family:微軟正黑體; font-size:12pt; font-weight:bold">第七條 帳號密碼遭非法使用之通知與處理</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">一、 當事人</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">一</span>
						<span
							style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">方如發現帳號、密碼被非法使用時，應立即通知對方並由企業經營者進行查證，經企業經營者確認有前述情事後，得暫停該組帳號或密碼之使用權，更換帳號或密碼予消費者，立即限制第三人就本遊戲服務之使用權利，並將相關處理方式揭載於遊戲管理規則。</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
							<span	style="background-color: rgb(255, 255, 255); font-family: 微軟正黑體; font-size: 12pt;">
						二、企業經營者應於暫時限制遊戲使用權利之時起，即刻以官網公告、簡訊、電子郵件、推播或其他雙方約定之方式通知前項第三人提出說明。如該第三人未於接獲通知時起七日內提出說明，企業經營者應直接回復遭不當移轉之電磁紀錄予消費者，不能回復時可採其他雙方同意之相當補償方式，並於回復後解除對第三人之限制。但企業經營者有提供免費安全裝置（例如：防盜卡、電話鎖等）而消費者不使用或有其他可歸責於消費者之事由，如帳號共用、帳號糾紛導致電磁紀錄遭不當轉移或刪除，企業經營者不負回復或補償責任。
					</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">三、
							第一項之第三人不同意企業經營者前項之處理時，消費者得依報案程序，循司法途徑處理。</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">四、
							企業經營者依第一項規定限制消費者或第三人之使用權時，在限制使用期間內，企業經營者不得向消費者或第三人收取費用。</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">五、
							消費者如有申告不實之情形致生企業經營者或第三人權利受損時，應負一切法律責任。</span>
						<br />
						<span style="font-family:微軟正黑體; font-size:12pt">&#xa0;</span>
					</p>
					<p style="background-color:#ffffff; margin:15pt 0pt 7.5pt">
						<span style="font-family:微軟正黑體; font-size:12pt; font-weight:bold">第八條 遊戲歷程之保存期限、查詢方式及費用</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">一、
							企業經營者應保存消費者之個人遊戲歷程紀錄，且保存期間為三十日，以供消費者查詢。</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">二、
							消費者得以書面、網路，或親至企業經營者之服務中心申請調閱消費者之個人遊戲歷程，且須提出與身分證明文件相符之個人資料以供查驗，查詢費用為新臺幣貳佰元整，由消費者負擔。</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">三、
							企業經營者接獲消費者之查詢申請，應提供第一項所列之消費者個人遊戲歷程，並於七日內以儲存媒介或書面、電子郵件方式提供資料。</span>
						<br />
						<span style="font-family:微軟正黑體; font-size:12pt">&#xa0;</span>
					</p>
					<p style="background-color:#ffffff; margin:15pt 0pt 7.5pt">
						<span style="font-family:微軟正黑體; font-size:12pt; font-weight:bold">第九條 個人資料</span>
					</p>
					<p style="margin:0pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">關於個人資料之保護，依相關法律規定處理。</span>
					</p>
					<p style="background-color:#ffffff; margin:15pt 0pt 7.5pt">
						<span style="font-family:微軟正黑體; font-size:12pt; font-weight:bold">第十條 電磁紀錄</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">一、 本遊戲之所有電磁</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">紀錄均屬企業</span>
						<span
							style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">經營者所有，企業經營者並應維持消費者相關電磁紀錄之完整。</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">二、
							消費者對於前項電磁紀錄有使用支配之權利。但不包括本遊戲服務範圍外之移轉、收益行為。</span>
						<br />
						<span style="font-family:微軟正黑體; font-size:12pt">&#xa0;</span>
					</p>
					<p style="background-color:#ffffff; margin:15pt 0pt 7.5pt">
						<span style="font-family:微軟正黑體; font-size:12pt; font-weight:bold">第十一條 連線品質</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">一、
							企業經營者為維護本遊戲服務相關系統及軟硬體設備而預先規劃暫停本遊戲服務之全部或一部時，應於七日 前於官</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">方粉絲團</span>
						<span
							style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">、遊戲登入頁面或購買頁面公告。但因臨時性、急迫性或不可歸責於企業經營者之事由者，不在此限。</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">二、
							因可歸責企業經營者事由，致消費者不能連線使用本遊戲服務時，企業經營者應立即更正或修復。對於消費
							者於無法使用期間遭扣除遊戲費用或遊戲內商品，企業經營者應返還遊戲費用或商品，無法返還時則應提供其他合理之補償。</span>
						<br />
						<span style="font-family:微軟正黑體; font-size:12pt">&#xa0;</span>
					</p>
					<p style="background-color:#ffffff; margin:15pt 0pt 7.5pt">
						<span style="font-family:微軟正黑體; font-size:12pt; font-weight:bold">第十二條 企業經營者及消費者責任</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">一、
							企業經營者應依本契約之規定負有於提供本服務時，維護其自身電腦系統，符合當時科技或專業水準可合理期待之安全性。</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">二、
							電腦系統或電磁紀錄受到破壞，或電腦系統運作異常時，企業經營者應於採取合理之措施後儘速予以回</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">覆</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">。</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">三、
							企業經營者違反前二項規定或因遊戲程式漏洞致生消費者損害時，應依消費者受損害情形，負損害賠償責任。但企業經營者能證明其無過失者，得減輕其賠償責任。</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">四、
							企業經營者電腦系統發生第二項所稱情況時，於完成修復並正常運作之前，企業經營者不得向消費者收取費用。</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">五、
							消費者因共用帳號、委託他人付費購買點數衍生與第三人間之糾紛，企業經營者得不予協助處理。</span>
						<br />
						<span style="font-family:微軟正黑體; font-size:12pt">&#xa0;</span>
					</p>
					<p style="background-color:#ffffff; margin:15pt 0pt 7.5pt">
						<span style="font-family:微軟正黑體; font-size:12pt; font-weight:bold">第十三條 遊戲管理規則</span>
					</p>
					<p style="margin:0pt">
						<span
							style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">使用者請遵守遊戲管理規章，若違反下述所列，本公司得依所示之方式進行處理。凡暫時停權者，停權開始日起七天內未主動聯絡客服中心，將依我方查獲事實按遊戲規章辦理，使用者必須自行承擔遊戲帳號連帶之所有損失、損害與責任，以及一切道具／遊戲幣／點數使用時限等損失，本公司將不負任何賠償及退還相關費用或法律責任。</span>
					</p>
					<p style="margin:0pt">
						<span style="font-family:微軟正黑體; font-size:12pt">&#xa0;</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">一、
							為規範遊戲進行之方式，企業經營者應訂立合理公平之遊戲管理規則，消費者應遵守企業經營者公告之遊戲 管理規則。</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">二、 遊戲管理規則之變更應依第十六點之程序為之。</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">三、 遊戲管理規則有下列情形之</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">一</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">者，其規定無效：</span>
						<br />
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">1. 牴觸本契約之規定。</span>
						<br />
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">2.
							剝奪或限制消費者之契約上權利。但企業經營者依第十四點之規定處理者，不在此限。</span>
						<br />
						<span style="font-family:微軟正黑體; font-size:12pt">&#xa0;</span>
					</p>
					<p style="background-color:#ffffff; margin:15pt 0pt 7.5pt">
						<span style="font-family:微軟正黑體; font-size:12pt; font-weight:bold">第十四條 違反遊戲管理規則之處理</span>
					</p>
					<p style="margin:0pt 0pt 0pt 28.3pt; text-indent:-28.3pt">
						<span style="font-family:微軟正黑體; font-size:12pt">一、</span>
						<span style="font:7.0pt 'Times New Roman'">&#xa0; </span>
						<span
							style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">除本契約另有規定外，有事實足證消費者於本遊戲服務中違反遊戲管理規則時，企業經營者應於遊戲登入頁面或購買頁面公告，並依消費者登入之通訊資料通知消費者。</span>
					</p>
					<p style="margin:0pt 0pt 0pt 28.3pt; text-indent:-28.3pt">
						<span style="font-family:微軟正黑體; font-size:12pt">二、</span>
						<span style="font:7.0pt 'Times New Roman'">&#xa0; </span>
						<span
							style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">消費者第一次違反遊戲管理規則，企業經營者應通知消費者於一定期間內改善。經企業經營者通知改善而未改善者，企業經營者得依遊戲管理規則，按其情節輕重限制消費者之遊戲使用權利。如消費者因同一事由再次違反遊戲管理規則時，企業經營者得立即依遊戲管理規則限制消費者進行遊戲之權利。</span>
					</p>
					<p style="margin:0pt 0pt 0pt 28.3pt; text-indent:-28.3pt">
						<span style="font-family:微軟正黑體; font-size:12pt">三、</span>
						<span style="font:7.0pt 'Times New Roman'">&#xa0; </span>
						<span
							style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">企業經營者依遊戲管理規則限制消費者進行遊戲之權利，每次不得超過七日，若因違反遊戲管理規章內重大情節事項者，不在此限。</span>
					</p>
					<p style="margin:0pt">
						<span style="font-family:微軟正黑體; font-size:12pt">&#xa0;</span>
					</p>
					<p style="background-color:#ffffff; margin:15pt 0pt 7.5pt">
						<span style="font-family:微軟正黑體; font-size:12pt; font-weight:bold">第十五條 申訴權利</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">一、
							消費者不滿意企業經營者提供之連線品質、遊戲管理、費用計費、其他相關之服務品質，或對企業經營者依
							遊戲管理規則之處置不服時，得於收到通知之翌日起七日內至企業經營者之服務中心或以電子郵件或書面提出申訴，企業經營者應於接獲申訴後，於十五日內回覆處理之結果。</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">二、 企業經營者</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">應於官網或</span>
						<span
							style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">遊戲管理規則中明定服務專線、電子郵件等相關聯絡資訊與二十四小時申訴管道。</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">三、
							消費者反映第三人利用外掛程式或其他影響遊戲公平性之申訴，依第一項規定辦理。</span>
						<br />
						<span style="font-family:微軟正黑體; font-size:12pt">&#xa0;</span>
					</p>
					<p style="background-color:#ffffff; margin:15pt 0pt 7.5pt">
						<span style="font-family:微軟正黑體; font-size:12pt; font-weight:bold">第十六條 契約之變更</span>
					</p>
					<p style="margin:0pt 0pt 0pt 30pt; text-indent:-30pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">一、</span>
						<span style="font:7.0pt 'Times New Roman'">&#xa0;&#xa0;&#xa0; </span>
						<span
							style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">企業經營者修改本契約時，應於遊戲登入頁面或購買頁面公告之，並依消費者登入之通訊資料</span>
					</p>
					<p style="margin:0pt 0pt 0pt 30pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">通知消費者。</span>
					</p>
					<p style="margin:0pt">
						<span
							style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">二、企業經營者未依前項進行公告及通知者，其契約之變更無效。</span>
						<br />
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">三、消費者於第一項通知到達後十五日內：</span>
						<br />
						<span
							style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">1.消費者未為反對之表示者，企業經營者依契約變更後之內容繼續提供本遊戲服務。</span>
						<br />
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">2.消費者為反對之表示者，依消費者終止契約方式處理。</span>
						<br />
						<span style="font-family:微軟正黑體; font-size:12pt">&#xa0;</span>
					</p>
					<p style="background-color:#ffffff; margin:15pt 0pt 7.5pt">
						<span style="font-family:微軟正黑體; font-size:12pt; font-weight:bold">第十七條 契約之終止及退費</span>
					</p>
					<p style="margin:0pt 0pt 0pt 28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">一、</span>
						<span style="font:7.0pt 'Times New Roman'">&#xa0; </span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">消費者得隨時通知企業經營者終止本契約。</span>
					</p>
					<p style="margin:0pt 0pt 0pt 28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">二、</span>
						<span style="font:7.0pt 'Times New Roman'">&#xa0; </span>
						<span
							style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">企業經營者得與消費者約定，若消費者逾一年未登入使用本遊戲服務，企業經營者得通知消費者於十五日內登入，如消費者屆期仍未登入使用，則企業經營者得終止本契約。</span>
					</p>
					<p style="margin:0pt 0pt 0pt 28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">三、</span>
						<span style="font:7.0pt 'Times New Roman'">&#xa0; </span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">消費者有下列重大情事之</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">一</span>
						<span
							style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">者，企業經營者依消費者登入之通訊資料通知消費者後，得立即終止本契約：</span>
						<br />
						<span
							style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">1.利用任何系統或工具對企業經營者電腦系統之惡意攻擊或破壞。</span>
						<br />
						<span
							style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">2.以利用外掛程式、病毒程式、遊戲程式漏洞或其他違反遊戲常態設定或公平合理之方式進行遊戲。</span>
						<br />
						<span
							style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">3.以冒名、詐騙或其他虛偽不正等方式付費購買點數或遊戲內商品。</span>
					</p>
					<p style="margin:0pt 0pt 0pt 28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt"> </span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">(</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">例如代儲</span>
						<span
							style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">、非法點數卡、非法信用卡、非法轉帳等方式)，企業經營者將不承擔任何交易衍生之風險，且亦有權力拒絕此筆交易訂單。</span>
						<br />
						<span style="font-family:微軟正黑體; font-size:12pt">4</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">.
							因同一事由違反遊戲管理規則達三次以上，經依第十四條第二項通知改善而未改善者。</span>
						<br />
						<span style="font-family:微軟正黑體; font-size:12pt">5</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">. 經司法機關查獲從事任何不法之行為。</span>
					</p>
					<p style="margin:0pt 0pt 0pt 0.1pt; padding-left:28.2pt; text-indent:-28.2pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">四、
							企業經營者對前項事實認定產生錯誤或無法舉證時，企業經營者應對消費者之損害負賠償責任。</span>
					</p>
					<p style="margin:0pt 0pt 0pt 0.1pt; padding-left:28.2pt; text-indent:-28.2pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">五、 契約終止時，企業經營者於扣除必要成本後，應於</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">三</span>
						<span
							style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">十日內以現金、信用卡、匯票或掛號寄發支票方式退還消費者未使用之付費購買之點數或遊戲費用，或依雙方同意之方式處理前述點數或費用。</span>
						<br />
						<span style="font-family:微軟正黑體; font-size:12pt">&#xa0;</span>
					</p>
					<p style="background-color:#ffffff; margin:15pt 0pt 7.5pt">
						<span style="font-family:微軟正黑體; font-size:12pt; font-weight:bold">第十八條 停止營運</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">一、
							因企業經營者停止本遊戲服務之營運而終止契約者，應於終止前三十日公告於官</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">方粉絲團</span>
						<span
							style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">、遊戲登入頁面或購買頁面；若消費者於註冊帳號時已登入通訊資料者，並依消費者登入之通訊資料通知消費者。</span>
					</p>
					<p style="margin:0pt; padding-left:28.3pt; text-indent:-28.3pt">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">二、
							企業經營者未依前項期間公告並通知者，除應退還消費者未使用之付費購買點數或遊戲費用且不得扣除必要 成本外，並應提供消費者其他合理之補償。</span>
						<br />
						<span style="font-family:微軟正黑體; font-size:12pt">&#xa0;</span>
					</p>
					<p style="background-color:#ffffff; margin:15pt 0pt 7.5pt">
						<span style="font-family:微軟正黑體; font-size:12pt; font-weight:bold">第十九條 管轄法院</span>
					</p>
					<p style="margin:0pt; orphans:0; padding-left:28.3pt; text-indent:-28.3pt; widows:0">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">一、
							消費者與企業經營者如發生法律訴訟，合意以中華民國現行法律為</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">準</span>
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">並以台灣台北地方法院為第一審管轄法院。</span>
					</p>
					<p style="margin:0pt; orphans:0; padding-left:28.3pt; text-indent:-28.3pt; widows:0">
						<span style="background-color:#ffffff; font-family:微軟正黑體; font-size:12pt">二、
							前項約定不得排除消費者保護法第四十七條及民事訴訟法第二十八條第二項、第四百三十六條之九規定之適用。</span>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CustomerContactus',
	data: function () {
		return {}
	},
}
</script>

<style lang="stylus" scoped>
.v-enter, .v-enter-to {
  opacity: 0;
}

.v-enter-active, .v-leave-active {
  transition: opacity 1s;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  border-radius: 3px;
  background: rgba(252, 197, 5, 0.06);
  -webkit-box-shadow: inset 0 0 5px rgba(252, 197, 5, 0.08);
}

::-webkit-scrollbar-thumb {
  wifth: 6px;
  height: 6px !important;
  border-radius: 3px;
  background: rgba(252, 197, 5, 0.8);
  -webkit-box-shadow: inset 0 0 10px rgba(252, 197, 5, 1);
}

.cs_title {
  width: 902px;

  h2 {
    position: relative;
    display: block;
    width: 100%;
    text-indent: 30px;
    font-size: 47.02px;
    color: #4b4b4b;
    font-weight: 500;
    text-indent: 55px;
    margin-bottom: 40px;

    &::before {
      content: '';
      position: absolute;
      width: 36px;
      height: 41px;
      top: 50%;
      left: 342px;
      margin-top: -18px;
      background: url('../../assets/imgs/hms-icon.png') no-repeat center;
      background-size: 298px 276px;
      background-position: -203px -91px;
    }
  }
}

.cus_login_wrapper {
  position: absolute;
  width: 900px;
  height: 667px;
  border: 3px solid #898888;
  box-sizing: border-box;
	overflow-y: auto;

  .login_box {
    margin: 0 auto;

    .c_content {
      overflow-y: auto;
      width: 800px;
      margin: 0 auto;
      height: 511px;
      line-height: 24px;
      margin-top: 10px;
      padding: 20px;
      border: 2px solid #898888;
      text-align: left;
      font-size: 14px;

      p {
        width: 100%;
        text-align: left;
        font: size 16px;
        font-weight: 700;
        margin-top: 20px;
        margin-bottom: 10px;

        &.title {
          font-size: 16px;
          text-align: center;
        }

        &.ind {
          text-indent: 2em;
          font-weight: inherit;
        }
      }
    }

    .con {
      li {
        position: relative;
        text-align: left;
        font-size: 20px;

        &.mart {
          margin-top: 38px;
          margin-bottom: 18px;
          text-indent: 2rem;

          &::before {
            content: '';
            position: absolute;
            width: 25px;
            height: 26px;
            top: 0;
            left: 0;
            background: url('../../assets/imgs/hms-icon.png') no-repeat center;
            background-size: 298px 276px;
            background-position: -230px -155px;
          }
        }
      }
    }

    .form {
      dl {
        overflow: inherit;
      }

      .con {
        width: 290px;
      }
    }

    .login_close {
      position: absolute;
      width: 89px;
      height: 82px;
      right: 0;
      top: 0;
      border-top-right-radius: 30%;
      background: url('../../assets/imgs/close.png') no-repeat center;
      background-size: 100% 100%;
      cursor: pointer;

      i {
        display: inline-block;
        width: 31.67px;
        height: 5.65px;
        position: absolute;
        right: 9px;
        top: 18px;
        background: #ffffff;
        border-radius: 2.5px;
      }
    }

    .logo {
      display: inline-block;
      width: 460px;
      margin: 17px auto 10px;
      font-size: 26px;
      color: #4b4b4b;
      padding-bottom: 10px;
      border-bottom: 3px solid #fcc505;

      i {
        display: inline-block;
        width: 70px;
        height: 51px;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -35px;
        margin-top: -25.5px;
        background: #4b4b4b;
        border-radius: 2.5px;
      }
    }

    .icon {
      span {
        display: inline-block;
        color: #545454;
        font-size: 14px;
        vertical-align: top;
        margin-right: 25px;
        margin-top: 8px;
      }

      div {
        display: inline-block;
        width: 39px;
        height: 46px;
        margin-top: 8px;
        background: url('../../assets/imgs/game-icon.png') no-repeat center;
        background-size: 500px 500px;
        cursor: pointer;

        &.gg {
          background-position: 0 -166px;
        }

        &.tw {
          background-position: -61px -166px;
        }

        &.fb {
          background-position: -123px -166px;
        }
      }
    }

    .login_reg {
      a {
        color: #2c2c2c;
        font-size: 14px;
      }
    }
  }
}
</style>
